import React from 'react';
const avatars = [{
  src: 'https://cdn.magicpatterns.com/uploads/otdxAPsiLM4NSAwvjvizYg/image.png',
  position: '60% 35%'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qjU76Prc33qP47eZjvS6FD/image.png',
  position: '40% 55%'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ck5pwprDEj6CFg6roxn2QJ/image.png',
  position: '50% 30%'
}];

/** Avatars décoratifs de la capsule de confiance. */
export function HeroAvatars() {
  return <span aria-hidden="true" className="flex shrink-0 -space-x-2" data-id="element-110" data-mp="w99by8aw7s9g">
      {avatars.map(a => <img key={a.src} src={a.src} alt="" decoding="async" className="h-8 w-8 rounded-full object-cover ring-2 ring-ivory" style={{
      objectPosition: a.position
    }} data-id="element-111" data-mp="wbltwlgni2mi" />)}
    </span>;
}